export default __webpack_public_path__ + "static/media/DCL.f1a4995e.png";